import { ReactElement, useMemo } from 'react';
import { Typography, Stack } from '@mui/material';

import { ImporterProgressProps } from './types';
import {
  ImporterProgressContainer,
  ImporterProgressProgressContainer,
  ImporterProgressLinearProgress,
  ImporterProgressLinearProgressText,
} from './styles';

const ImporterProgress = ({
  title,
  description: descriptionProp,
  errors,
  progress,
  warning = false,
}: ImporterProgressProps): ReactElement => {
  const isCompleted = useMemo(() => progress >= 100, [progress]);

  const descriptions = useMemo(
    () =>
      typeof descriptionProp === 'string'
        ? [descriptionProp]
        : [...descriptionProp],
    [descriptionProp],
  );

  const color = useMemo(
    () => (warning ? 'warning' : isCompleted ? 'success' : 'primary'),
    [isCompleted, warning],
  );

  return (
    <ImporterProgressContainer>
      <Typography>{title}</Typography>

      {descriptions.map((description, descriptionIndex) => (
        <Typography
          key={`importer-progress-description-${descriptionIndex}`}
          variant="caption"
          color="text.secondary"
        >
          {description}
        </Typography>
      ))}

      {errors && errors.length > 0 && (
        <Stack marginBottom={3}>
          <Typography
            variant="caption"
            color="text.secondary"
            fontWeight="bold"
          >
            Errores:
          </Typography>

          {errors.map((error, errorIndex) => (
            <Typography
              key={`importer-progress-errors-${errorIndex}`}
              variant="caption"
              color="text.secondary"
              fontSize={(currenTheme) => currenTheme.typography.pxToRem(11)}
            >
              {error}
            </Typography>
          ))}
        </Stack>
      )}

      <ImporterProgressProgressContainer>
        <ImporterProgressLinearProgress
          variant="determinate"
          value={progress}
          color={color}
        />

        <ImporterProgressLinearProgressText variant="body2" fontWeight={500}>
          {`${progress}%`}
        </ImporterProgressLinearProgressText>
      </ImporterProgressProgressContainer>
    </ImporterProgressContainer>
  );
};

export default ImporterProgress;
